export enum FeatureType {
    business_prospects_list
}
